// @ts-nocheck
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import CompanyIcon from '@material-ui/icons/Business';
import DeleteIcon from '@material-ui/icons/DeleteForeverOutlined';
import EditIcon from '@material-ui/icons/Edit';
import CloudIcon from '@material-ui/icons/ImportExport';
import RoleIcon from '@material-ui/icons/VerifiedUser';
import { Entity, ctx as L20NContext } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { BLUE, PERMISSIONS, PERMISSION_ENTITIES, RED } from '../../_config/consts.js';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import CustomFieldsDisplayView from '../CustomFields/CustomFieldsDisplayView.jsx';
import PrivateUnitsIconCustom from '../CustomIcons/PrivateUnitsIconCustom.jsx';
import Tag from '../../components/Tag.jsx';
import RemoveEmailIconCustom from '../CustomIcons/RemoveEmailIconCustom.jsx';

const styles = {
  hoverMenu: {
    position: 'absolute',
    right: -17,
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'white',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 0',
    zIndex: 1000,
  },
  menuButton: {
    padding: 10,
    paddingLeft: 13,
    paddingRight: 13,
    margin: '2px 0',
  },
};

class GuestDetailsRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  onHandleMouseEnter = () => {
    this.setState({ isHovered: true });
  }

  onHandleMouseLeave = () => {
    this.setState({ isHovered: false });
  }

  onHandleDelete() {
    const { onDeleteGuestRequest, guest } = this.props;
    if (onDeleteGuestRequest) {
      onDeleteGuestRequest(guest);
    }
  }

  onHandleEdit() {
    const { onEditGuestRequest, guest } = this.props;
    if (onEditGuestRequest) {
      onEditGuestRequest(guest);
    }
  }

  render() {
    const { guest, privateUnits, themeName, hideFakeTag, onClick, isSelected, onOpenPrivateUnitRequest, classes } = this.props;
    const { isHovered } = this.state;
    const isPrivateUnitUser = guest.privateUnit
    const privateUnitId = guest.privateUnitId
    const privateUnit = privateUnitId && privateUnits.find(e=>e.id===privateUnitId) || undefined
    const userShort = isPrivateUnitUser ? `PU` : `${guest.firstname.charAt(0).toUpperCase()}${guest.lastname.charAt(0).toUpperCase()}`;
    const canReadUserTags = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.USER_TAG);
    
    const statusColor = !guest.enabled && !guest.withoutEmail ? '#E53935' : '#43A047';

    const canDeleteGuest = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.DELETE], PERMISSION_ENTITIES.USER);
    const canEditGuest = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.UPDATE], PERMISSION_ENTITIES.USER);

    return (
      <div
        style={{ position: 'relative', marginBottom: 20 }}
        onMouseEnter={this.onHandleMouseEnter}
        onMouseLeave={this.onHandleMouseLeave}
      >
        <Card
          style={{ borderRadius: 10, padding: 20, position: 'relative', borderLeft: `4px solid ${statusColor}` }}
          className={`card card-rounded ${(!onClick || isPrivateUnitUser) && 'card-noHover'} ${isSelected && 'card-selected'}`}
          onClick={onClick && !isPrivateUnitUser ? () => onClick() : null}
          elevation={2}
        >
        <div className="card-body">
          <div className={`rounded-view lock-icon bg-${themeName || 'default'}-theme`}>
            {isPrivateUnitUser ? (
              <PrivateUnitsIconCustom style={{ width: 26 }} />
            ): (
              <h3 style={{ color: 'white', margin: 0 }}>{userShort}</h3>
            )}
          </div>
          <div className="card-inner-body">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              {isPrivateUnitUser ? (
                <div style={{ width: '90%', display: 'flex', overflow: 'overlay', flexDirection: 'column' }}>
                  <h4 className="card-title" style={{ marginLeft: 5 }}>{`[PU] ${(privateUnit && privateUnit.name) || ""}`}</h4>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                    <h5 className="card-description" style={{ margin: 5 }}>{`${L20NContext.getSync('guest')} ${guest.id}`}</h5>
                  </div>
                </div>
              ) : (
                <div style={{ width: '90%', display: 'flex', overflow: 'overlay', flexDirection: 'column' }}>
                  <h4 className="card-title" style={{ marginLeft: 5 }}>{`${guest.firstname} ${guest.lastname}`}</h4>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                    {guest.withoutEmail ?  (
                      <div style={{ display: 'flex', marginTop: 7, marginLeft: 5, marginBottom: 5, flexDirection: 'row', alignItems: 'center' }}>
                        <RemoveEmailIconCustom style={{ color: '#3f3f3f', width: 15, marginRight: 5 }} />
                        <h5 style={{ color: '#3f3f3f', margin: 0 }}><Entity entity="noEmailSet" /></h5>
                      </div>
                    ) : (<h5 className="card-description" style={{ margin: 5 }}>{guest.email}</h5>)}
                    {guest.companyName ? (
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginRight: 10, marginBottom: 2 }}>
                        |
                        <CompanyIcon style={{ fontSize: 17, marginLeft: 5, color: '#3f3f3f' }} />
                        <h5 style={{ fontSize: 14, margin: 0, marginLeft: 5, color: '#3f3f3f', fontWeight: 200 }}>{guest.companyName}</h5>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
            </div>
            {!isPrivateUnitUser && 
              <CustomFieldsDisplayView
                textStyle={{ fontSize: 15 }}
                iconStyle={{ width: 15 }}
                containerStyle={{ marginBottom: 5, marginLeft: 5 }}
                customFields={guest.customFields}
              />
            }
            {canReadUserTags && !isPrivateUnitUser && (
              <div className="tags-container" style={{ margin: 0, marginRight: 20 }}>
                {guest && guest.userTag && !hideFakeTag && <Tag tag={guest.userTag} />}
                {_.map(guest.tags, tag =>
                  <Tag
                    key={tag.id}
                    tag={tag}
                  />,
                )}
              </div>
            )}
            {isPrivateUnitUser && privateUnitId ? (
              <div>
                <Button
                  onClick={(event) => {
                    event.stopPropagation();
                    onOpenPrivateUnitRequest(privateUnitId);
                  }}
                  style={{color: BLUE, fontSize: 12, fontWeight: 'bold', textDecoration: 'underline',}}
                >
                  {`${L20NContext.getSync('openPrivateUnit')}`}
                  <PrivateUnitsIconCustom style={{ width: 20, marginLeft: 5 }} />
                </Button>
              </div>
            ):null}
          </div>
        </div>
        {guest.extId && !isPrivateUnitUser ? <p style={{ margin: 0, alignSelf: 'flex-start' }} data-tip={L20NContext.getSync('guestSyncFromSource')}><CloudIcon style={{ color: '#4DB6AC', position: 'absolute', top: 12, right: guest.isGuestManager ? 27 : 6, marginRight: 10, marginLeft: 0, fontSize: 22 }} /></p> : null}
        {guest.isGuestManager && !isPrivateUnitUser ? <p style={{ margin: 0 }} data-tip={L20NContext.getSync('guestIsManager')}><RoleIcon style={{ color: 'orange', position: 'absolute', top: 6, right: 6, marginTop: 3, fontSize: 22 }} /> </p> : null}
        <Entity
          key={`${guest.enabled}-${guest.withoutEmail}`}
          style={{ fontWeight: 'bold', position: 'absolute', right: 6, bottom: 6, textTransform: 'uppercase', color: statusColor, textAlign: 'right', fontSize: 12, margin: 0, marginTop: 10 }}
          entity={!guest.enabled && !guest.withoutEmail  ? 'userDisabled' : 'userEnabled'}
        />
        <ReactTooltip delayShow={200} effect="float" />
      </Card>
      {isHovered && !isPrivateUnitUser && (canEditGuest || canDeleteGuest) && (
        <div className={classes.hoverMenu}>
          {canEditGuest ? (
            <IconButton 
              className={classes.menuButton}
              onClick={(event) => {
                event.stopPropagation();
                this.onHandleEdit();
              }}
              size="small"
              aria-label="edit"
            >
              <EditIcon style={{ fontSize: 20, color: BLUE }} />
            </IconButton>
          ) : null}
          {canDeleteGuest ? (
            <IconButton 
              className={classes.menuButton}
              onClick={(event) => {
                event.stopPropagation();
                this.onHandleDelete();
              }}
              size="small"
              aria-label="delete"
            >
              <DeleteIcon style={{ fontSize: 20, color: RED }} />
            </IconButton>
          ) : null}
        </div>
      )}
      </div>
    );
  }
}

export default withStyles(styles)(GuestDetailsRow);
